import React from 'react';
import xImg from '../images/twitter.png';
import teleImg from '../images/telegram.png';
import blockstarImg from '../images/blockstar.png';

export default function Footer() {
  return (
    <footer className="text-white py-4 mt-5 absolute bottom-0">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          {/* Copyright Text */}
          <p className="mb-0">blockstar.site &copy; {new Date().getFullYear()} All rights reserved</p>

          {/* Social Media Icons */}
          <div>

            <a href="https://x.com/BlockStar_BST" className="text-white me-3" target="_blank" title="Twitter">
              <img src={xImg} alt='x' height="25px" width="25px" />
            </a>
            <a href="https://t.me/BlockStar_Announcements" className="text-white me-3" target="_blank" title="Instagram">
              <img src={teleImg} alt='x' height="30px" width="30px" />
            </a>
            <a href="https://blockstar.social/BlockStar" className="text-white" target="_blank" title="LinkedIn">
              <img src={blockstarImg} alt='x' height="30px" width="30px" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
